'use client';

import React, { useState } from 'react';
import { Swiper as SwiperType } from 'swiper';
import { FreeMode, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { IFeature } from 'app/interfaces/common';
import SwiperButtonPrev from 'app/components/common/SwiperButtonPrev';
import SwiperButtonNext from 'app/components/common/SwiperButtonNext';
import { defaultProcessText } from 'app/utility/textProcessing';
import ImageBg from 'app/components/common/ImageBg';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

export default function BenefitSlider({ items }: { items: IFeature[] }) {
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);

  return (
    <>
      <Swiper
        spaceBetween={-12}
        breakpoints={{
          768: {
            spaceBetween: -24
          },
          1920: {
            spaceBetween: 0
          }
        }}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[FreeMode, Thumbs]}
        className="rounded"
      >
        {items.map(({ image }, index) => (
          <SwiperSlide key={index} className="px-3 md:px-6 4xl:px-0">
            <div className="relative w-full pb-[59%] md:pb-[56%] xl:pb-[46%]">
              {!!image && (
                <ImageBg
                  src={image?.url}
                  alt={image.alt ?? ''}
                  fill
                  placeholderDataURL={image.placeholder_data_url}
                  className="object-cover rounded"
                />
              )}
            </div>
          </SwiperSlide>
        ))}
        <div className="absolute z-10 right-6 md:right-12 xl:right-13 bottom-3.5 md:bottom-6 xl:bottom-7 flex gap-1 justify-end">
          <SwiperButtonPrev />
          <SwiperButtonNext />
        </div>
      </Swiper>

      <Swiper
        onSwiper={setThumbsSwiper}
        spaceBetween={0}
        breakpoints={{
          768: {
            slidesPerView: 4
          }
        }}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Thumbs]}
        className="mt-5 md:mt-6 xl:mt-4"
      >
        {items.map(({ title, description }, index) => (
          <SwiperSlide key={index} className="group px-3 md:px-6 4xl:px-0">
            <div className="flex flex-col gap-3 max-w-[220px] cursor-pointer">
              {!!title && (
                <div
                  className="text-p2 xl:text-p2 opacity-40 group-[&.swiper-slide-thumb-active]:opacity-100 uppercase"
                  dangerouslySetInnerHTML={{
                    __html: defaultProcessText(title)
                  }}
                />
              )}

              {!!description && (
                <div
                  className="opacity-0 group-[&.swiper-slide-thumb-active]:opacity-100 text-p3"
                  dangerouslySetInnerHTML={{
                    __html: defaultProcessText(description)
                  }}
                />
              )}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
